import { Trans } from 'react-i18next';

import { Anchor, Body1 } from '@myphx-engineering/phx-design-system';
import { openTalkativeUI } from '@phx/talkative';

export const CancelledDescription = () => (
    <Body1>
        <Trans
            i18nKey="priorAuthorization.statusPage.cancelled"
            components={{
                2: <Anchor onClick={openTalkativeUI} />,
            }}
        />
    </Body1>
);
